import React from 'react';
import { MessageOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import { useTranslate } from '@/translations';
import type { ConversationTarget } from '../context/ConversationDrawerContext';
import './MinimizedConversationButton.scss';

interface MinimizedConversationButtonProps {
  operator: ConversationTarget;
  onClick(): void;
}

export const MinimizedConversationButton = ({
  operator,
  onClick,
}: MinimizedConversationButtonProps) => {
  const { t } = useTranslate();
  const displayName = operator.displayName ?? `Operator ${operator.userId}`;
  const label = `${t('commsChatWith')} ${displayName}`;

  return (
    <FloatButton
      className="comms-conversation-float-button"
      icon={<MessageOutlined />}
      description={label}
      tooltip={label}
      aria-label={label}
      shape="square"
      onClick={onClick}
    />
  );
};
